import React, { useEffect, useState } from 'react'
import Sidebar from '../components/sidebar';
import Topbar from '../components/topbar';
import Button from 'react-bootstrap/Button';
import { Modal, Pagination } from 'react-bootstrap';
import axios from "../axiosInstance";
import { useNavigate } from 'react-router-dom';
import { errorMessage } from '../hooks/UserLogs';
import * as XLSX from "xlsx";

export default function DepotPerAgency() {
    const [totalPage, setTotalPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [ListUserLogs, setListUserLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showError, setShowError] = useState(false);
    const [errMsg, setErrorMsg] = useState("Une erreure s'est produite!!");
    const [ListAgents, setListAgents] = useState([]);
    const [totalpageAgency,setTotalpageAgency]=useState(2);
    
    const [statusTransaction, setStatusTransaction] = useState('P');
    const convertToDate=(resultDate)=>{
        const yyyy = resultDate.getFullYear();
        let mm = resultDate.getMonth(); // Months start at 0!
        let dd = resultDate.getDate();
        mm=mm+1;
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        return yyyy+'-'+mm+'-'+dd+'T00:00:00.000Z';
    }
    
    const axiosInstance = axios.create({
                            withCredentials: true,
                          })

    const getListAgency = async () => {
      //A changer
      let ulr = "/agencies?page=" + 1 + "&limit=6000000";
     
      const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
        
        setIsLoading(false)

        if (err?.response?.status == 401 || err?.response?.status == 403) {
          setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
          setShowError(true);
        }else{
          let msg=errMsg+ ' ' +err?.response?.status?(err?.response?.status):'';
          setErrorMsg(msg);
          setShowError(true);
        }
        console.error(err);
        
  
      });
      if (response) {
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
        setListAgents(response.data.body);
        
        if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }
      }
    }

    let defaultBgDate = new Date()
    defaultBgDate.setDate(defaultBgDate.getDate() - 7)
    let defaultEndDate = new Date()
    defaultEndDate.setDate(defaultEndDate.getDate() +1)
    const [beginDate,setBeginDate]=useState(defaultBgDate);
    const [endDate,setEndDate]=useState(defaultEndDate);
    const [idAgency,setidAgency]=useState("");
    
    const navigate = useNavigate();
    const bUrl = process.env.REACT_APP_B_URL;

    const getUserLogs = async (bgDate,edDate,idAgency) => {
        setBeginDate(new Date(bgDate));
        setEndDate(new Date(edDate));
        setidAgency(idAgency);
        let bgDateConvert=convertToDate(new Date(bgDate));
        let endDateConvert=convertToDate(new Date(edDate));
        let ulr = "/invoice-startup-master/deposit-per-agency?beginDate="+bgDateConvert+"&endDate="+endDateConvert+"&status="+statusTransaction;
        if (idAgency!= '') {
            ulr+="&idAgency="+idAgency;
        }
       
        const response = await axios.get(bUrl + ulr).catch((err) => {
          console.log(err);
          setIsLoading(false)
    
        });

        if (response) {

          if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }else{
          setListUserLogs(response.data.body);
          setTotalPage(response.data.totalPage);
          setCurrentPage(response.data.currentPage);
          
        }

        setIsLoading(false);

        if (response.status == 401) {
          navigate('/backoffice/login');
        }

        }
    }
   
    const dataToExcel =async ()=>{

      let bgDateConvert=convertToDate(new Date(beginDate));
        let endDateConvert=convertToDate(new Date(endDate));
        let ulr = "/invoice-startup-master/deposit-per-agency?page=1&limit="+10*totalPage+"&begenDate="+bgDateConvert+"&endDate="+endDateConvert+"&status="+statusTransaction;
        if (idAgency!= '') {
            ulr+="&idAgency="+idAgency;
        }
       
        const response = await axios.get(bUrl + ulr).catch((err) => {
          console.log(err);
          setIsLoading(false)
    
        });

        if (response) {

          if (response?.data?.isError) {
          const msg = errorMessage(response?.data?.code)
          setErrorMsg(msg);
          setShowError(true);
        }else{
          
          const filterListAgent=response.data.body.map(({name,code,totalAmount,count})=>({
            Nom:name,
            Code: code,
            Nombre:count,
            Total: totalAmount,
          }))
    
          const ws = XLSX.utils.json_to_sheet(filterListAgent);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "depotAgency");
          XLSX.writeFile(wb, "depot_agency.xlsx");
          
        }

        setIsLoading(false);

        if (response.status == 401) {
          navigate('/backoffice/login');
        }

        }
          
        }

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
        return new Date(dateString).toLocaleDateString(undefined, options)
      }
    const handleCloseError = () => {
        setShowError(false);
      }
      useEffect(()=>{
        if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
          //console.log("----------GO GO GO ------------")
          navigate('/backoffice/login');
        }
        getListAgency();
        getUserLogs(beginDate, endDate, idAgency);

      },[currentPage]);

    return (
        <div className="App">
      <div className="">

        <Sidebar />
        <section className="home ">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="table-content mt-2 p-2 text d-flex justify-content-between">
                <div><p className='fw-bold'>Déposit de crédit par agence</p></div>
                <div><Topbar /></div>
              </div>
              <div className="table-content mt-3 p-3">
                <div className="d-flex justify-content-around">
                  <div className="form-group text">
                    <label htmlFor="exampleInputEmail1">Début</label>
                    <input type="Date" value={beginDate.toLocaleDateString('en-CA')} onChange={(e) => getUserLogs(e.target.value, endDate, idAgency)} className="form-control" id="exampleInputEmail1"  />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="phone">Fin</label>
                    <input type="Date" value={endDate.toLocaleDateString('en-CA')} onChange={(e) => getUserLogs(beginDate, e.target.value, idAgency)} className="form-control" id="phone" aria-describedby="Phone" placeholder="Phone" />
                  </div>
                  <div className="form-group text">
                    <label htmlFor="code">Agent</label>
                    <select className="form-select form-select-lg mb-3" aria-label=".form-select-lg example" value={idAgency}  onChange={(e) => getUserLogs(beginDate, endDate, e.target.value)}>
                          <option value="">Sélectionnez Agent</option>
                          {ListAgents!=null?  ListAgents.length > 0 ? ListAgents.map((a, i) => {
                            return <option value={a.idAgency} key={i}>{a.code}</option>
                          }
                          ):'':''}
                      </select>                  
                      </div>
                </div>
              </div>
              <div className="table-content mt-3 p-3">

              <div className="d-flex flex-row-reverse">
                <div>
                  <span onClick={() => dataToExcel()} className="clickable">
                    <i className='bx bx-printer bx-sm'></i>
                  </span>
                </div>
              </div>

                <div className="table-responsive-xl">
                  {isLoading ? <div className='loading'><img src='../Custom.svg' /></div> :
                    <table className="table text">
                      <thead>
                        <tr>

                          <th scope="col">N°</th>
                          <th scope="col">Nom</th>
                          
                          <th scope="col">Code</th>
                          <th scope="col">Nombre</th>
                          <th scope="col">Montant</th>
                          <th></th>
                          <th></th>

                        </tr>
                      </thead>

                      <tbody>
                        {ListUserLogs!=null?ListUserLogs.length > 0 ? ListUserLogs.map((a, i) => {
                          return <tr key={i}>
                            <td>{i}</td>
                            <td>{a.name}</td>
                            <td>{a.code}</td>
                            <td>{a.count}</td>
                            <td>{a.totalAmount}</td>
                          </tr>
                        }) : <tr></tr>:''}
                      </tbody>

                    </table>
                  }
                </div>
                <Pagination totalPage={totalPage} setCurrentPage={setCurrentPage} currentPage={currentPage} />              </div>

            </div>
          </div>
        </section>
      </div>
      

      {/* =============================================error=============================== */}
      <Modal show={showError} onHide={handleCloseError} className="">
        <Modal.Header closeButton className="bg-danger">
          <Modal.Title>ERROR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseError}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    )
}
